interface State {
  version?: string;
}

const initialState: State = {
  version: '2.0',
};

export default initialState;
